export enum CabinetReferenceType {
  Common = 1,
  Document = 2
}
